<template>
      <div class="box">
        <h4>导入数据</h4>
        <el-table :data="tableData" border empty-text="暂无数据" style="width: 100%">
            <el-table-column type="index" :label="'序号'" width="50" align="center"> </el-table-column>
            <el-table-column prop="dormitoryName" :label="'宿舍名'" width="120" align="center" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="status" :label="'宿舍状态'" width="120" align="center" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                    {{ scope.row.status==0?'正常':'关闭' }}
                </template>
            </el-table-column>
            <el-table-column prop="gender" :label="'宿舍属性'" width="120" align="center" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="buildingName" :label="'所属宿舍楼'" width="120" align="center" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="managerName" :label="'宿管名字'" width="120" align="center" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="managerContact" :label="'宿管联系方式'" width="120" align="center" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="className" :label="'分配班级'" width="120" align="center" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="major" :label="'分配专业'" width="120" align="center" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="dormitoryName" :label="'导入说明'" align="center" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                    {{ scope.row.passenger.importResult }}
                </template>
            </el-table-column>
        </el-table>
      </div>
</template>

<script>
export default {
    props: {

    },
    data() {
        return {
            tableData: []
        }
    },
    computed: {},
    watch: {},
    created: function() {
    },
    mounted: function() {
        let data = JSON.parse(this.$route.query.data)
        this.tableData = [...data.resultList, ...data.successList]
    },
    methods: {
    }
}
</script>

<style scoped>
.box {
    height: 100%;
    padding:10px 20px;
    background-color: #f2f5fb;
    font-size: 14px;
    font-weight: 500;
}
table {
    border-collapse: collapse; /* 合并边框 */
    width: 100%;
  }
  table, th, td {
    border: 1px solid black; /* 设置边框 */
  }
</style>

